import { render, staticRenderFns } from "./ProductPacking.vue?vue&type=template&id=2e621168"
import script from "./ProductPacking.vue?vue&type=script&lang=js"
export * from "./ProductPacking.vue?vue&type=script&lang=js"
import style0 from "./ProductPacking.vue?vue&type=style&index=0&id=2e621168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports